import { HttpClient } from '@angular/common/http';
import { from, Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ServerTypes } from 'src/app/models/servers';
import { ApplicationResource } from '../models/application-resource';
import { mockResources } from './mock/mock-resources';
import { AuthService } from 'src/app/services/auth.service';

@Injectable({ providedIn: 'root' })
export class ApplicationResourcesApi {
  constructor(private httpClient: HttpClient, private authService: AuthService, private apiService: ApiService) {}

  create(resource: ApplicationResource<any>): Observable<any> {
    let baseUrl = this.apiService.getCurentServer(ServerTypes.boapi);
    let url = '/v1/applications/resources/';

    return this.httpClient.post(baseUrl + url, resource);
  }

  delete(resourceId: string): Observable<any> {
    let baseUrl = this.apiService.getCurentServer(ServerTypes.boapi);
    let url = '/v1/applications/resources/' + resourceId;

    return this.httpClient.delete(baseUrl + url);
  }

  update(resource: ApplicationResource<any>): Observable<any> {
    let baseUrl = this.apiService.getCurentServer(ServerTypes.boapi);
    let url = '/v1/applications/resources/' + resource.id;

    return this.httpClient.put(baseUrl + url, resource);
  }

  getApplicationResource(id: string): Observable<ApplicationResource<any>> {
    let baseUrl = this.apiService.getCurentServer(ServerTypes.boapi);
    let url = '/v1/applications/resources/' + id;

    return this.httpClient.get<ApplicationResource<any>>(baseUrl + url);
  }

  getAll(): Observable<GetApplicationResourcesResponse> {
    if(!this.authService.isAuthenticated()) return of<GetApplicationResourcesResponse>(); 
    let baseUrl = this.apiService.getCurentServer(ServerTypes.boapi);
    let url = '/v1/applications/resources/';

    //return this.mockGet();
    return this.get(baseUrl, url);
  }

  private get(baseUrl: any, url: string) {
    return this.httpClient.get<GetApplicationResourcesResponse>(baseUrl + url);
  }

  private mockGet() { 
    return of(mockResources as GetApplicationResourcesResponse);
  }
}

export interface GetApplicationResourcesResponse
  extends Array<ApplicationResource<any>> {}
